<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="10%" v-if="!isOperator")
          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th(width="10%")
          span(:title="$t('ui.promo_id')") {{ $t('ui.promo_id') }}
        th(width="32%")
          span(:title="$t('ui.promo_name')") {{ $t('ui.promo_name') }}
        th.text-right(width="15%")
          span(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
        th.text-right(width="15%")
          span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
        th.text-right(width="15%")
          span(:title="$t('ui.claim_frequency')") {{ $t("ui.claim_frequency") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="!isOperator ? '7': '6'").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td(v-if="!isOperator")
          span(:title="item.operator_id") {{ item.operator_id }}
        td
          span(:title="item.promotion_id") {{ item.promotion_id }}
        td
          span(:title="item.promotion_name") {{ item.promotion_name }}
        td.text-right
          span.font-weight-bold(:title="$n(item.deposit_amount, 'currency')" :class="$helpers.fontClassName(item.deposit_amount)") {{ $n(item.deposit_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.claim_frequency, 'integer')") {{ $n(item.claim_frequency, 'integer') }}
      tr.footer
        td.text-right(:colspan="!isOperator ? '4' : '3'")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountSummary)" :title="$n(grandTotalDepositAmountSummary, 'currency')") {{ $n(grandTotalDepositAmountSummary, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountSummary)" :title="$n(grandTotalBonusAmountSummary, 'currency')") {{ $n(grandTotalBonusAmountSummary, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(grandTotalClaimFrequencySummary, 'currency')") {{ $n(grandTotalClaimFrequencySummary, 'integer') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    grandTotalDepositAmountSummary: 0,
    grandTotalBonusAmountSummary: 0,
    grandTotalClaimFrequencySummary: 0
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.grandTotalDepositAmountSummary = 0
      this.grandTotalBonusAmountSummary = 0
      this.grandTotalClaimFrequencySummary = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalDepositAmountSummary = totalTbl[0]["deposit_amount"];
          this.grandTotalBonusAmountSummary = totalTbl[0]["bonus_amount"];
          this.grandTotalClaimFrequencySummary = totalTbl[0]["claim_frequency"];
        }
      }
    }
  }
};
</script>
